import React from 'react';
import { Progress } from 'antd';
import { brand, neutral, semantic } from '../../../theme/tokens';
import { tone } from './tones';

const STROKE = {
    brand: brand[600],
    success: semantic.success.solid,
    warning: semantic.warning.solid,
    danger: semantic.danger.solid,
    info: semantic.info.solid,
    violet: semantic.violet.solid,
    neutral: neutral[500]
};

/** Quiet metric tile used inside cards (no border): label, value, optional progress bar and hint. */
export default function MetricTile({ label, value, suffix, hint, tone: toneName, progress }) {
    return (
        <div className="h-full rounded-lg bg-surface-50 px-4 py-3.5">
            <div className="text-[13px] font-medium text-surface-500">{label}</div>
            <div className="mt-1.5 flex items-baseline gap-1">
                <span className={`text-2xl font-semibold tracking-tight tabular-nums leading-none ${toneName ? tone(toneName).text : 'text-surface-900'}`}>
                    {value}
                </span>
                {suffix && <span className="text-sm font-medium text-surface-500">{suffix}</span>}
            </div>
            {progress !== undefined && (
                <Progress
                    percent={progress}
                    showInfo={false}
                    strokeColor={STROKE[toneName] || STROKE.brand}
                    trailColor={neutral[200]}
                    size={['100%', 6]}
                    className="!mb-0 !mt-3"
                />
            )}
            {hint && <div className="mt-2 text-xs text-surface-500">{hint}</div>}
        </div>
    );
}
